import type { IconData } from '@stacksjs/iconify-core'

export const caretTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M496 400.357H16.333v-36.449L256.047 96L496 365.81Zm-440.708-32h400.149L255.975 144.07Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default caretTop
